module.exports = __webpack_public_path__ + "img/189.01fa57d9.png";